export default "/images/ece8dd6b631428b3db8ceabbf776a14f.avif";